import axios from '../api/axiosSetup3';
import { Origin } from '../types/origin';
import { OriginType } from '../types/originType';
import { Entity } from '../types/entity';
import { WireguardConf } from '../types/vpn';

const ORIGIN_PARENT_TYPE = 2;

const get = async (): Promise<Origin[]> => {
    // const customer_id = import.meta.env.VITE_CUSTOMER_ID;
    // const res = await instance.get<Origin[]>(`/lpr_origin?customer_id=eq.${customer_id}`);

    // const res = await axios.get('/lpr_origin?select=*,lpr_entity(parent_id)');
    // return res.data.map((record: any) => {
    //   const { lpr_entity, ...data } = record;
    //   return {...data, parent_id: lpr_entity ? lpr_entity.parent_id : null};
    // });

    const res = await axios.get('/v_origin'); // using view for RLS
    return res.data;
};

const getOriginTypes = async (): Promise<OriginType[]> => {
    // const customer_id = import.meta.env.VITE_CUSTOMER_ID;
    const res = await axios.get<OriginType[]>(`/lpr_origin_type?enabled=is.true`);
    return res.data;
};

const getEntities = async (): Promise<Entity[]> => {
    // const customer_id = import.meta.env.VITE_CUSTOMER_ID;
    const res = await axios.get<Entity[]>(`/lpr_entity?type=eq.2`);
    return res.data;
};

// const _post = async (data: Origin): Promise<Origin> => {
//     const { parent_id, ...origin } = data;
//     const entity = { parent_id, name: data.name, type: ORIGIN_PARENT_TYPE };
//     const res1 = await instance.post<Entity>('/lpr_entity', entity);
//     const res2 = await instance.post<Origin>('/lpr_origin', origin);
//     return res1.status === 201 && res2.status === 201 ? data : {} as Origin;
// }

interface OriginPostData {
  v_entity_id: number;
}

const post = async (data: Origin): Promise<Origin> => {
    const { entity_id: omit, success, ...origin } = data;
    const res = await axios.post<OriginPostData[]>('/rpc/sf_origin_post', origin);
    
    if (res.data.length == 0) return {} as Origin;

    const entity_id = res.data[0].v_entity_id;
    const newOrigin: Origin = {...origin, entity_id, success: false};
    return res.status === 200 ? newOrigin : {} as Origin;
}

const _put = async (data: Origin): Promise<Origin> => {
    const { parent_id, ...origin } = data;
    const res = await axios.patch<Origin>(`/lpr_origin?origin_id=eq.${data.entity_id}`, data);
    return res.status === 204 ? data : {} as Origin;
}

const put = async (data: Origin): Promise<Origin> => {

    const payload = { ...data };
    if (payload.wg_conf_id as any === '') {
      payload.wg_conf_id = null
    }
    const { success, customer_id, ...data1 } = payload;

    // const { success, customer_id, ...data1 } = data;

    // put не поддерживается
    const res = await axios.post('/rpc/sf_origin_put', data1);
    return res.status === 204 ? data : {} as Origin;
}

const delete_ = async (entity_id: number): Promise<void> => {
  //  await axios.delete<Origin>(`/lpr_entity?entity_id=eq.${entity_id}`);
    await axios.patch(`/lpr_origin?entity_id=eq.${entity_id}`, {is_deleted: true});
}

// interface OriginCredentials {
//   origin_type_id: number;
//   credentials: Object;
// }

// const checkConnection = async (data: Origin): Promise<{ok: boolean, success: boolean | null, description: string | null}> => {
const checkConnection_ = async (data: Origin): Promise<{ok: boolean, result: string | null, }> => {
  console.log('[originApi] checkConnection called :', data);
  try {
    // const res = await axios.post('/check_connection/', data);

    // SELECT plates_action(5, 'check')
    // CREATE OR REPLACE FUNCTION "lpr"."plates_action"("origin_id" int4, "action" text, "plates" _text=NULL::text[])
    const res = await axios.post('/rpc/plates_action', {
      origin_id: data.entity_id,
      action: 'check',
    });
    return {...res.data, ok: true};
  } catch (err) {
    console.error('[originApi] Error during checkConnection:', err);
    return {ok: false, result: null };
  }
};

// проверка при заданных параметрах подключения (применять при неизвестном origin_id)
const checkConnection = async (data: Origin): Promise<{ok: boolean, result: string | null, }> => {
  console.log('[originApi] checkConnection called :', data);
  try {
    const res = await axios.post('/rpc/api_camera', {
      origin_id: 0,
      entry: 'check_connection',
      data: {
        origin_type_id: data.origin_type_id, 
        credentials: data.credentials,
        wg_conf_id: data.wg_conf_id,
      }
    });
    return {result: res.data.message, ok: res.data.result};
  } catch (err) {
    console.error('[originApi] Error during checkConnection:', err);
    return {ok: false, result: null };
  }
};

const checkConnection__ = async (data: Origin): Promise<{ok: boolean, result: string | null, }> => {
  console.log('[originApi] checkConnection called :', data);
  try {
    const res = await axios.post('/rpc/api_camera', {
      origin_id: data.entity_id,
      entry: 'check_connection',
    });
    return {result: res.data.message, ok: res.data.result};
  } catch (err) {
    console.error('[originApi] Error during checkConnection:', err);
    return {ok: false, result: null };
  }
};

export interface OriginImage {
    image: string;
    result: boolean;
}

const getSnapshot = async ({ origin_id, }: { origin_id: number; uuid: string }): Promise<OriginImage> => {
    const res = await axios.post<OriginImage>('/rpc/get_snapshot', { origin_id, });
    return res.data;
}

export interface ValueLabel {
  value: string;
  label: string;
}

const getVpnConfigVL = async (): Promise<ValueLabel[]> => {
    const res = await axios.get<WireguardConf[]>(`/wireguard_conf`, {
        headers: {
            'Accept-Profile': 'public' // schema
        }        
    });
    return res.data.map((conf) => ({
      value: String(conf.id),
      label: conf.name,
    }));
}

export const api = {
    getOriginTypes,
    getEntities,
    get,
    post,
    put,
    delete: delete_,
    checkConnection,
    getSnapshot,
    getVpnConfigVL,
};